import React, { useState } from 'react'
import { api } from '../../utils/api'

// Same limit as the worker route (warehouse-system/workers/src/routes/returns.js).
export const NOTE_MAX = 300

/**
 * The customer wants an item back (spec 20261102). Asks for an optional note,
 * then moves the item to "return requested". The same dialog serves Issue
 * Trades and the deal modal on the Payments page, so both say the same thing
 * and show Prism's refusal the same way (it refuses a paid item).
 *
 * `item` is { quoteItemId, name }. Calls onDone(response) once the item has moved.
 */
function ReturnRequestDialog({ dealId, item, onDone, onClose }) {
  const [note, setNote] = useState('')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState(null)

  async function handleConfirm() {
    setSaving(true)
    setError(null)
    try {
      const response = await api.post('/api/warehouse/returns/request', {
        dealId,
        quoteItemId: item.quoteItemId,
        note: note.trim() || undefined
      })
      onDone(response)
    } catch (err) {
      setError(err.message || 'Could not request the return. Try again.')
      setSaving(false)
    }
  }

  return (
    <div className="modal-overlay" onClick={saving ? undefined : onClose}>
      <div
        className="modal-content"
        role="dialog"
        aria-modal="true"
        aria-labelledby="return-request-title"
        onClick={(e) => e.stopPropagation()}
        style={{ maxWidth: 480, width: '100%' }}
      >
        <div className="modal-header">
          <h3 id="return-request-title" style={{ margin: 0, fontSize: 18 }}>Customer wants it back</h3>
          <button className="modal-close" onClick={onClose} disabled={saving} aria-label="Close">×</button>
        </div>

        <div style={{ padding: 16, display: 'flex', flexDirection: 'column', gap: 12 }}>
          <div style={{ fontSize: 15 }}>
            <strong>{item.name}</strong> leaves this list and is not paid for.
            It goes to To send back.
          </div>

          <label style={{ display: 'flex', flexDirection: 'column', gap: 6, fontSize: 14, fontWeight: 600 }}>
            Note (optional)
            <textarea
              className="form-input"
              rows={3}
              maxLength={NOTE_MAX}
              value={note}
              onChange={(e) => setNote(e.target.value)}
              disabled={saving}
              style={{ fontSize: 16, fontWeight: 400 }}
            />
          </label>

          {error && <div role="alert" style={{ color: '#E5625E', fontSize: 14 }}>{error}</div>}
        </div>

        <div className="modal-footer" style={{ display: 'flex', gap: 12, padding: 16 }}>
          <button className="btn btn-secondary" onClick={onClose} disabled={saving} style={{ minHeight: 44, flex: 1 }}>
            Cancel
          </button>
          <button className="btn btn-danger" onClick={handleConfirm} disabled={saving} style={{ minHeight: 44, flex: 1 }}>
            {saving ? 'Saving...' : 'Customer wants it back'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default ReturnRequestDialog
